import { Component, Input } from '@angular/core';

import { CompanyIntegrationsModel } from '../companies/models/company.integrations';
import { WsApiSettingsModel }       from '../ws-api/typings/ws-api.settings.model';

@Component({
  selector   : 'wor-api-settings',
  template: require('./api-settings.component.html')
})
export class ApiSettingsComponent {
  @Input() bookingsApiSettings: any;
  @Input() integrations       : CompanyIntegrationsModel;
  @Input() wsApiSettings      : WsApiSettingsModel;
}
